import { StylesConfig } from 'react-select';

export const styles: StylesConfig = {
  control: (provided: object, state: { isFocused: boolean; isDisabled: boolean }) => ({
    ...provided,
    transition: '200ms',
    backgroundColor: 'white',
    borderWidth: '2px',
    borderRadius: '0.25rem',
    borderColor: state.isFocused ? 'black' : '#DDE3E8',
    opacity: state.isDisabled ? '.5' : '1',
    boxShadow: undefined,
    minHeight: '38px',
    height: '38px',
    '&:hover': {
      borderColor: state.isFocused ? '' : '#DDE3E8',
    },
  }),
  dropdownIndicator: (provided: object) => ({
    ...provided,
    color: '#DDE3E8',
  }),
  indicatorSeparator: (provided: object) => ({
    ...provided,
    backgroundColor: '#f7fafc',
  }),
  multiValue: (provided: object) => ({
    ...provided,
    color: 'white',
    backgroundColor: '#0259fe',
  }),
  multiValueLabel: (provided: object) => ({
    ...provided,
    color: 'white',
  }),
  multiValueRemove: (provided: object) => ({
    ...provided,
    color: 'white',
    cursor: 'pointer',
    transition: '100ms',
    ':hover': {
      backgroundColor: '#0150e6',
      color: 'white',
    },
  }),
  option: (provided: object) => ({
    ...provided,
    color: '#6A7785',
    backgroundColor: 'rgba(2, 89, 254, 0)',
    ':hover': {
      color: '#6A7785',
      backgroundColor: 'rgba(2, 89, 254, 0.05)',
    },
    cursor: 'pointer',
  }),
  placeholder: () => ({
    color: '#edf2f7',
  }),
  clearIndicator: () => ({
    color: '#0259fe',
    lineHeight: 0.5,
  }),
  valueContainer: (provided: object) => ({
    ...provided,
    height: '26px',
    padding: '0 6px',
  }),
  input: (provided: object) => ({
    ...provided,
    margin: '0px',
  }),
  indicatorsContainer: (provided: object) => ({
    ...provided,
    height: '36px',
  }),
  singleValue: (provided: object) => ({
    ...provided,
    color: 'rgb(63, 81, 98)',
  }),
  menu: (provided: object) => ({
    ...provided,
    zIndex: 20,
  }),
};
